import script from "./FormInicioSesion.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormInicioSesion.vue?vue&type=script&setup=true&lang=ts"

import "./FormInicioSesion.vue?vue&type=style&index=0&id=55dc747b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55dc747b"]])

export default __exports__